import React from 'react'
import style from './style.module.css'

const year = new Date().getFullYear()

const PoweredBy = () => {

    return (
        <div className={style.poweredBy}>
            <a href='https://inspireleadershipnetwork.com' target='_blank' rel='noopener noreferrer noindex nofollow'>&copy; {year} Inspire Leadership Network. All rights reserved.</a>
        </div>
    )

}

export default PoweredBy